import type { z } from 'zod';

import { schemaEuropaceAntrag_Export } from '../../Antrag_Export.schema';

/*
    https://docs.api.europace.de/privatkredit/angebote/kex-angebote-api/#antrag
 */

export const schemaEuropaceAntrag = schemaEuropaceAntrag_Export
    .pick({
        antragsnummer: true,
        bonitaetsrechnung: true,
        dokumente: true,
        identifikationAntragsteller1: true,
        identifikationAntragsteller2: true,
        machbarkeit: true,
        produktanbieterantragsnummer: true,
        ratenkredit: true,
        ratenschutz: true,
    })
    .extend({
        gesamtkonditionen: schemaEuropaceAntrag_Export.shape.gesamtkonditionen
            .unwrap()
            .omit({ monatlicheRate: true })
            .extend({
                rateMonatlich: schemaEuropaceAntrag_Export.shape.gesamtkonditionen.unwrap().shape.monatlicheRate,
            })
            .optional(),
    });

export type SchemaEuropaceAntrag = z.infer<typeof schemaEuropaceAntrag>;
